import React, {Component} from 'react';

export default class ScaleView extends Component {

    render() {

        let scale = this.props.item;
        if(!scale){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>Balanza</h3>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Código</label>
                        <p className={"field-p"}>{scale.code}</p>
                    </div>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Terminal</label>
                        <p className={"field-p"}>{scale.terminal.name}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(scale, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ScaleView.js